module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-11b36c45b8d9201fd891d6d89a635eb9.png";